<div class="bg-white surface-card border-round shadow-2">
  <!-- Header -->
  <div class="flex justify-content-between align-items-center p-4 border-bottom-1 surface-border">
    <button pButton icon="pi pi-chevron-left" (click)="previousMonth()" class="p-button-rounded p-button-text"></button>
    <h2 class="text-xl font-semibold m-0">
      {{ currentMonth | date:'MMMM yyyy' }}
    </h2>
    <button pButton icon="pi pi-chevron-right" (click)="nextMonth()" class="p-button-rounded p-button-text"></button>
  </div>

  <!-- View Toggle -->
  <div class="border-bottom-1 surface-border">
    <div class="flex gap-2 p-2">
      <button pButton [label]="'Calendar'" icon="pi pi-calendar" [outlined]="activeTab !== 'calendar'"
        (click)="activeTab = 'calendar'" [class.p-button-outlined]="activeTab !== 'calendar'"
        class="p-button-rounded"></button>
      <button pButton [label]="'List'" icon="pi pi-list" [outlined]="activeTab !== 'list'" (click)="activeTab = 'list'"
        [class.p-button-outlined]="activeTab !== 'list'" class="p-button-rounded"></button>
    </div>
  </div>

  <!-- Calendar View -->
  <div class="card surface-overlay p-4" *ngIf="activeTab === 'calendar'">
    <!-- Weekday Headers -->
    <div class="grid">
      <div *ngFor="let day of weekDays" class="col text-center font-medium text-600 p-3">
        {{ day }}
      </div>
    </div>

    <!-- Calendar Grid -->
    <div class="grid gap-3"> <!-- Changed background color here -->
      <ng-container *ngFor="let week of calendar">
        <div *ngFor="let day of week" [pTooltip]="hasNoteForDate(day.date) ? 'Click to view note' : ''"
          tooltipPosition="top" class="col cursor-pointer relative" [class.surface-hover]="day.date"
          [class.shadow-2]="day.date" [class.border-round-xl]="day.date" [class.hover:shadow-4]="day.date"
          [class.transition-all]="day.date" [class.duration-200]="day.date" [class.font-bold]="hasNoteForDate(day.date)"
          (click)="handleDateClick(day.date)">

          <!-- Date Number -->
          <div class="p-3 text-center">
            {{ day.date | date:'d' }}
          </div>

          <!-- Note Indicator -->
          <div *ngIf="hasNoteForDate(day.date)" class="absolute top-0 right-0 m-2">
            <i class="pi pi-circle-fill text-primary text-sm"></i>
          </div>

          <!-- Today Indicator -->
          <div *ngIf="isToday(day.date)" class="absolute top-0 left-0 m-2">
            <span class="bg-primary-100 text-primary-900 text-xs px-2 py-1 border-round">
              Today
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- List View -->
  <div class="p-2" *ngIf="activeTab === 'list'">
    <div *ngIf="getNotesForMonth().length === 0" class="text-center text-600 py-8">
      No notes for this month
    </div>
    <div *ngFor="let note of getNotesForMonth()" class="p-4 border-bottom-1 surface-border hover:surface-hover">
      <div class="flex align-items-center gap-4">
        <div class="bg-primary-500 px-3 py-2 border-round">
          <span class="font-semibold text-primary-900">
            {{ note[0] | date:'MMM d, yyyy' }}
          </span>
        </div>
        <div class="flex-1">
          <p class="text-700 m-0">{{ note[1] }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Selected Note Details -->
  <div *ngIf="selectedNote && activeTab === 'calendar'" class="border-top-1 surface-border p-4">
    <div class="flex align-items-center gap-2 mb-2">
      <i class="pi pi-tag text-primary"></i>
      <h3 class="font-medium m-0">Note Details</h3>
    </div>
    <p class="text-600 m-0">{{ selectedNote }}</p>
  </div>
</div>